// import { createProvider } from "./vue-apollo";
import * as GmapVue from "gmap-vue";
// import Access from "./plugins/access.js";
import App from "./App.vue";
import Dates from "./plugins/dates.js";
import Popover from "vue-js-popover";
import store from "./store";
import router from "./router";
import SvgIcon from "vue-svgicon";
import Util from "./plugins/util.js";
import VCalendar from "v-calendar";
import VModal from "vue-js-modal";
import Vue from "vue";
import VueCurrencyInput from "vue-currency-input";
import Vuelidate from "vuelidate";
import contenteditable from 'vue-contenteditable';
import VueTableDynamic from 'vue-table-dynamic';
import authContainer from "./lib/authContainer";

Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}

Vue.use({
  install: async (Vue, authContainer) => {
    await authContainer.init();
    Vue.prototype.$authContainer = authContainer;
  }
}, authContainer);

Vue.use(GmapVue, {
  load: {
    language: "en",
    region: "US",
    key: process.env.VUE_APP_GMAP_API_KEY,
    libraries: "places" // This is required if you use the Autocomplete plugin
  },
  installComponents: true
});

Vue.use(Dates);

Vue.use(Popover);

Vue.use(SvgIcon, { tagName: "svgicon" });

Vue.use(Util);

Vue.use(VCalendar, { firstDayOfWeek: 1 });

Vue.use(VModal); 

Vue.use(contenteditable);

Vue.use(VueTableDynamic)

const pluginOptions = {
  /* see config reference */
  globalOptions: { currency: null }
};
Vue.use(VueCurrencyInput, pluginOptions);

Vue.use(Vuelidate);

Vue.config.productionTip = false;

var app = new Vue({
  router,
  store, 
  render: h => h(App)
}).$mount("#app");

app.$store = store;